import React from 'react';
const HOURLY = [
  { hour: '6 AM', transactions: 18, revenue: 420.50, basket: 23.36 },
  { hour: '7 AM', transactions: 32, revenue: 890.20, basket: 27.82 },
  { hour: '8 AM', transactions: 45, revenue: 1620.80, basket: 36.02 },
  { hour: '9 AM', transactions: 52, revenue: 2140.50, basket: 41.16 },
  { hour: '10 AM', transactions: 48, revenue: 1890.30, basket: 39.38 },
  { hour: '11 AM', transactions: 65, revenue: 2840.60, basket: 43.70 },
  { hour: '12 PM', transactions: 78, revenue: 3420.40, basket: 43.85 },
  { hour: '1 PM', transactions: 62, revenue: 2650.90, basket: 42.76 },
  { hour: '2 PM', transactions: 38, revenue: 1420.20, basket: 37.37 },
  { hour: '3 PM', transactions: 42, revenue: 1680.50, basket: 40.01 },
];
const DEPT_SALES = [
  { dept: 'Produce', revenue: 8420, pct: 18.2 },
  { dept: 'Meat & Seafood', revenue: 12650, pct: 27.3 },
  { dept: 'Deli', revenue: 5890, pct: 12.7 },
  { dept: 'Bakery', revenue: 3240, pct: 7.0 },
  { dept: 'Dairy', revenue: 6780, pct: 14.6 },
  { dept: 'Frozen', revenue: 4120, pct: 8.9 },
  { dept: 'Beverages', revenue: 5430, pct: 11.3 },
];
export default function DailySalesPage() {
  const totalRev = HOURLY.reduce((a, h) => a + h.revenue, 0);
  const totalTx = HOURLY.reduce((a, h) => a + h.transactions, 0);
  const maxRev = Math.max(...HOURLY.map(h => h.revenue));
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Daily Sales</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Today's sales breakdown by hour and department</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        {[{ label: 'Revenue (so far)', value: '$' + totalRev.toLocaleString(undefined, { minimumFractionDigits: 2 }), color: '#16A34A' }, { label: 'Transactions', value: totalTx, color: 'var(--primary)' }, { label: 'Avg Basket', value: '$' + (totalRev / totalTx).toFixed(2), color: '#F59E0B' }].map((s, i) => (
          <div key={i} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
            <div style={{ color: 'var(--text-muted)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', marginBottom: 8 }}>{s.label}</div>
            <div style={{ color: s.color, fontSize: 24, fontWeight: 700 }}>{s.value}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', padding: 20 }}>
          <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Hourly Revenue</h3>
          {HOURLY.map(h => (
            <div key={h.hour} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <span style={{ color: 'var(--text-muted)', fontSize: 11, width: 48, textAlign: 'right' }}>{h.hour}</span>
              <div style={{ flex: 1, height: 16, background: 'var(--border)', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${(h.revenue / maxRev) * 100}%`, height: '100%', background: 'var(--primary)', borderRadius: 4 }} />
              </div>
              <span style={{ color: 'var(--text)', fontSize: 11, fontWeight: 600, width: 64, textAlign: 'right' }}>${h.revenue.toLocaleString()}</span>
            </div>
          ))}
        </div>
        <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', padding: 20 }}>
          <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Sales by Department</h3>
          {DEPT_SALES.map(d => (
            <div key={d.dept} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <span style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600, width: 120 }}>{d.dept}</span>
              <div style={{ flex: 1, height: 16, background: 'var(--border)', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${d.pct * 3}%`, height: '100%', background: '#16A34A', borderRadius: 4 }} />
              </div>
              <span style={{ color: '#16A34A', fontSize: 12, fontWeight: 700, width: 64, textAlign: 'right' }}>${d.revenue.toLocaleString()}</span>
              <span style={{ color: 'var(--text-muted)', fontSize: 11, width: 36 }}>{d.pct}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
